module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-french-bulldog-775c6b98.svg";